import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';


export default {


  topics(){
    return Firebase.firestore().collection('topics')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  
 
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/service.js